import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-firmar-pdf-masivo',
  templateUrl: './firmar-pdf-masivo.component.html',
  styleUrls: ['./firmar-pdf-masivo.component.scss']
})
export class FirmarPdfMasivoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
